var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-selector" },
    [
      _c("label", { attrs: { for: "room" + (_vm.index + 1) } }, [
        _vm._v("Room " + _vm._s(_vm.index + 1) + ":"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "room-selector__fields" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.roomId,
                expression: "roomId",
              },
            ],
            attrs: { id: "room" + (_vm.index + 1) },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.roomId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { domProps: { value: null } }, [
              _vm._v("Select room type"),
            ]),
            _vm._v(" "),
            _vm._l(_vm.availableRooms, function (availableRoom) {
              return _c(
                "option",
                {
                  key: availableRoom.id,
                  attrs: { disabled: !_vm.roomOptionAvailable(availableRoom) },
                  domProps: { value: availableRoom.id },
                },
                [_vm._v(_vm._s(availableRoom.name))]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            attrs: { "aria-label": "Remove room", title: "Remove this room" },
            on: { click: _vm.removeRoom },
          },
          [_vm._v("×")]
        ),
      ]),
      _vm._v(" "),
      _vm.room.passengers.length
        ? [
            _c("div", { staticClass: "room-selector__room-type" }, [
              _c(
                "span",
                { staticClass: "room-selector__people-icon" },
                _vm._l(_vm.room.occupancy, function (index) {
                  return _c(
                    "svg",
                    {
                      key: index,
                      attrs: {
                        width: "12",
                        height: "12",
                        role: "img",
                        "aria-hidden": "true",
                        focusable: "false",
                      },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href":
                            "/Static/images/sprites/symbols.svg#icon-room",
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "room-selector__room-description" }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.room.name) + " Occupancy Room(s)"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "(" +
                      _vm._s(_vm.room.occupancy) +
                      " " +
                      _vm._s(_vm.room.occupancy > 1 ? "people" : "person") +
                      ")"
                  ),
                ]),
                _vm._v(" "),
                _vm.room.supplement
                  ? _c("small", [
                      _vm._v(
                        "*" +
                          _vm._s(_vm.currency(_vm.room.supplement)) +
                          " Supplementary Charge"
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm._l(_vm.room.passengers, function (passenger, passengerIndex) {
              return _c(
                "div",
                {
                  key: passenger.key,
                  staticClass: "room-selector__passenger",
                  class: {
                    "room-selector__passengerTs":
                      _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
                  },
                },
                [
                  _c("h4", { staticClass: "room-selector__passenger-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("capitalize")(
                          _vm._f("numberToWordsOrdinal")(
                            _vm.globalPassengerIndex(_vm.index, passengerIndex)
                          )
                        )
                      ) + " Passenger"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "room-selector__passenger-row" },
                    [
                      _c("Input", {
                        ref: "firstName",
                        refInFor: true,
                        attrs: {
                          name: "firstName",
                          label: "First Name",
                          placeholder: "First Name",
                          startingValue: _vm.autofillName(
                            "firstName",
                            _vm.index,
                            passengerIndex
                          ),
                          required: true,
                          pattern: _vm.patterns.name,
                          title: _vm.titles.name,
                          vuexPath: _vm.vuexFieldPath(passengerIndex),
                          trim: true,
                        },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.saveToSessionStorage(
                              "firstName",
                              _vm.index,
                              passengerIndex,
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("Input", {
                        ref: "lastName",
                        refInFor: true,
                        attrs: {
                          name: "lastName",
                          label: "Last Name",
                          placeholder: "Last Name",
                          startingValue: _vm.autofillName(
                            "lastName",
                            _vm.index,
                            passengerIndex
                          ),
                          required: true,
                          pattern: _vm.patterns.name,
                          title: _vm.titles.name,
                          vuexPath: _vm.vuexFieldPath(passengerIndex),
                          trim: true,
                        },
                        nativeOn: {
                          input: function ($event) {
                            return _vm.saveToSessionStorage(
                              "lastName",
                              _vm.index,
                              passengerIndex,
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }